// Server-generated PDF reports: fetch and download.

export const fetchPdfFile = async (api, path, params, filename) => {
  const res = await api.get(path, { params, responseType: 'blob' });
  return new File([res.data], filename, { type: 'application/pdf' });
};

export const downloadFile = (file) => {
  const url = URL.createObjectURL(file);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = file.name;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
};
